import { ReactNode } from 'react';

/**
 * Card component that contains different UI elements
 */
export default function Card(props: { className?: string; children?: ReactNode }) {
  return (
    <div className={props.className}>
      {props.children}
    </div>
  );
}
